import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { getAllIdChecked } from '../../../../common/tree/helper'
import { keyBy } from '../../../../helpers/common'
import classes from '../../../index.module.scss'
import {
  selectIcb,
  selectIcbChecked,
  selectIcbTree,
  selectVsic,
  selectVsicChecked,
  selectVsicTree,
  setIcb,
  setIcbChecked,
  setVsic,
  setVsicChecked,
} from '../../store/slice'
import ListItem from './ListItem'

const SelectedItem = ({ isVsic, vsics, icbs }) => {
  const dispatch = useDispatch()

  const vsicId = useSelector(selectVsic)
  const vsicChecked = useSelector(selectVsicChecked)
  const vsicTree = useSelector(selectVsicTree)
  const icbId = useSelector(selectIcb)
  const icbChecked = useSelector(selectIcbChecked)
  const icbTree = useSelector(selectIcbTree)

  const [vsicById, setVsicById] = useState({})
  const [icbById, setIcbById] = useState({})

  useEffect(() => {
    if (vsics.length) {
      setVsicById(keyBy(vsics, 'id'))
    }
  }, [vsics])

  useEffect(() => {
    if (icbs.length) {
      setIcbById(keyBy(icbs, 'id'))
    }
  }, [icbs])

  const getTitle = () => (isVsic ? 'VSIC' : 'ICB')

  const getItemId = () => (isVsic ? vsicId : icbId)

  const getItemById = () => (isVsic ? vsicById : icbById)

  const deleteAll = () => {
    const setIdsChecked = isVsic ? setVsicChecked : setIcbChecked
    const setParentIdsChecked = isVsic ? setVsic : setIcb

    dispatch(setIdsChecked([]))
    dispatch(setParentIdsChecked([]))
  }

  const deleteItem = (id) => {
    const tree = isVsic ? vsicTree : icbTree
    const action = isVsic ? setVsicChecked : setIcbChecked
    const idChecked = isVsic ? vsicChecked : icbChecked
    const idDelete = getAllIdChecked(tree, 'id', [id])

    dispatch(action(idChecked.filter((id) => !idDelete.includes(id))))
  }

  return (
    <div className={classes.selectedItem}>
      <div className="dFlex justifyContentBetween alignItemsCenter">
        <Element
          elementName="span"
          className={classes.title}
          style={{ color: '#3a414b' }}
        >
          {getTitle()}
        </Element>
        <Icon
          onClick={deleteAll}
          className={`icon-trash-fill ${classes.trash}`}
          style={{ color: '#9c9c9c', fontSize: 15 }}
        />
      </div>
      <div className={classes.tableItem}>
        <div className={classes.tableContent}>
          <ScrollComponent>
            <ListItem
              itemId={getItemId()}
              itemById={getItemById()}
              deleteItem={deleteItem}
            />
          </ScrollComponent>
        </div>
      </div>
    </div>
  )
}

SelectedItem.propTypes = {
  isVsic: PropTypes.bool.isRequired,
  vsics: PropTypes.array.isRequired,
  icbs: PropTypes.array.isRequired,
}

export default SelectedItem
